import { gql } from '@common/hooks';
import { CSVError } from 'works/legacy/lib/csv_error';

export const ImportWorksMembership = gql`
  mutation ImportWorksMembership($input: ImportWorksMembershipInput!) {
    importWorksMembership(input: $input) {
      success
      uploadedMembers
      errors {
        row
        type
        field
        message
      }
    }
  }
`;

export type ImportWorksMembershipResponse = {
  importWorksMembership: {
    errors: CSVError[];
    uploadedMembers: string[];
    success: boolean;
  };
};

export type ImportWorksMembershipVariables = {
  input: {
    file: File;
  };
};
